import { useState } from 'react';
import { api } from '../../lib/api';

interface Props {
  label?: string;
  className?: string;
  /** Override the default publish action. If omitted, calls api.publish.trigger(). */
  onPublish?: () => Promise<void>;
  onPublished?: () => void;
  onError?: (err: Error) => void;
}

export default function PublishButton({ label = 'Publicar sitio', className, onPublish, onPublished, onError }: Props) {
  const [publishing, setPublishing] = useState(false);

  async function handleClick() {
    setPublishing(true);
    try {
      await (onPublish ? onPublish() : api.publish.trigger());
      onPublished?.();
    } catch (err) {
      onError?.(err instanceof Error ? err : new Error('No se pudo publicar el sitio'));
    } finally {
      setPublishing(false);
    }
  }

  return (
    <button
      type="button"
      disabled={publishing}
      onClick={handleClick}
      className={className ?? 'px-4 py-1.5 bg-ui-accent hover:bg-ui-accent-hover text-ui-text-inverse text-sm font-medium rounded-md disabled:opacity-50 transition-colors shadow-sm shadow-ui-accent/20'}
    >
      {publishing ? 'Publicando…' : label}
    </button>
  );
}
